import { useQuery, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { GET_CIP_QUERY_KEY } from '@/modules/employee/Employee/cip/queries/useCIPInfo.query';

export enum CipVerificationStatus {
  Success = 'PASS',
  Pending = 'PENDING',
  Error = 'FAIL',
}

interface CipResponse {
  status: CipVerificationStatus;
}

const QUERY_KEY = 'GET_CIP_VERIFICATION_STATUS';
export default (employeeId?: string) => {
  const queryClient = useQueryClient();
  const {
    refetch: handleCheck,
    isLoading,
    isError,
  } = useQuery(
    [QUERY_KEY],
    () =>
      // TODO: type is missing
      api.get<CipResponse>(API_URL.IDOLOGY_DOCUMENT_PROCESS_STATUS, {
        params: {
          employee_id: employeeId,
        },
      }),
    {
      enabled: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_CIP_QUERY_KEY],
        });
      },
    }
  );

  return {
    handleCheck,
    isLoading,
    isError,
  };
};
